import React from "react";
import ProductDetailsLeft from "./ProductDetailsLeft";
import ProductDetailRight from "./ProductDetailRight";

function Content() {
  return (
    <>
      <section className="bg-light">
        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-5 mt-5">
              <ProductDetailsLeft />
            </div>
            <div className="col-lg-7 mt-5">
              <ProductDetailRight />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Content;
